import { useTextStorage } from "../../../../hooks/TextStorageProvider"
import {
  testimonial1Avatar,
  testimonial2Avatar,
  testimonial1AvatarBg,
  testimonial2AvatarBg,
  testimonial1NameTag,
  testimonial2NameTag,
  testimonialDecor,
  testimonialDecor2,
} from "../../../../assets/images"
import "./TestimonialsSection.scss"
import classNames from "classnames"

export const TestimonialsSection: React.FC = () => {
  const { ts } = useTextStorage()
  return (
    <div className="testimonials-section">
      <h2>{ts.pages.home.testimonialsSection.title}</h2>
      <div className="testimonials-section--testimonials-container">
        {ts.pages.home.testimonialsSection.testimonials.map(
          (testimonial, index) => (
            <div
              key={testimonial.name}
              className="testimonials-section--testimonial-card"
            >
              <img
                src={index === 0 ? testimonial1AvatarBg : testimonial2AvatarBg}
                alt={testimonial.name}
                className="avatar-bg"
              />
              <img
                src={index === 0 ? testimonial1Avatar : testimonial2Avatar}
                alt={testimonial.name}
                className={classNames(
                  "avatar-image",
                  index === 0 ? "rotate-clockwise" : "rotate-counter-clockwise",
                )}
              />
              <p>{testimonial.text}</p>
              <div className="testimonials-section--testimonial-card--name-tag-container">
                <img
                  src={index === 0 ? testimonial1NameTag : testimonial2NameTag}
                  alt={testimonial.name}
                  className="tag"
                />
                <span>{testimonial.name}</span>
              </div>
              {index === 0 && (
                <img
                  src={testimonialDecor}
                  alt={testimonial.name}
                  className="decor-left"
                />
              )}

              <img
                src={testimonialDecor2}
                alt={testimonial.name}
                className="decor-right"
              />
            </div>
          ),
        )}
      </div>
    </div>
  )
}
